import { Component, ChangeDetectionStrategy, ViewEncapsulation, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DIALOG_CONFIG, DialogConfigExtended } from '../workbuddy.side.dialog.service';
import { CdkTrapFocus } from '@angular/cdk/a11y';

@Component({
    selector: 'w-dialog-container',
    template: `
        <ng-container *ngComponentOutlet="dialogConfig?.componentType; injector: dialogConfig?.injector; inputs: dialogConfig?.inputs"></ng-container>
    `,
    styleUrls: ['dialog.container.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        CdkTrapFocus
    ],
    hostDirectives: [
        CdkTrapFocus
    ]
})
export class DialogContainerComponent {

    protected dialogConfig = inject<DialogConfigExtended>(DIALOG_CONFIG, { optional: true });

    constructor() { }
}